module.exports = __webpack_public_path__ + "static/media/digital-exchange.da8af7ff.png";